"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VaultInfo = exports.MarketParams = exports.DesiredCDPState = exports.getCloseToCollateralParams = exports.getCloseToDaiParams = exports.getMultiplyParams = exports.OFFSET_MULTIPLAYER = void 0;
const bignumber_js_1 = require("bignumber.js");
const types_1 = require("./internal/types");
Object.defineProperty(exports, "DesiredCDPState", { enumerable: true, get: function () { return types_1.DesiredCDPState; } });
Object.defineProperty(exports, "MarketParams", { enumerable: true, get: function () { return types_1.MarketParams; } });
Object.defineProperty(exports, "VaultInfo", { enumerable: true, get: function () { return types_1.VaultInfo; } });
const utils_1 = require("./internal/utils");
const increaseDecreaseMP_1 = require("./internal/increaseDecreaseMP");
exports.OFFSET_MULTIPLAYER = new bignumber_js_1.BigNumber(1.00001);
function calculateIncrease(marketParams, vaultInfo, desiredCdp, debug = false) {
    let debtDelta;
    let collateralDelta;
    let loanFee;
    let oazoFee;
    let skipFL;
    skipFL = false;
    [debtDelta, collateralDelta, oazoFee, loanFee] = increaseDecreaseMP_1.calculateParamsIncreaseMP(marketParams.oraclePrice, marketParams.marketPrice, marketParams.OF, marketParams.FF, vaultInfo.currentCollateral.plus(desiredCdp.providedCollateral), vaultInfo.currentDebt.minus(desiredCdp.providedDai), desiredCdp.requiredCollRatio, marketParams.slippage, desiredCdp.providedDai, debug);
    const newDebt = vaultInfo.currentDebt.plus(debtDelta);
    const currentCollateralValue = vaultInfo.currentCollateral.times(marketParams.oraclePrice);
    if (currentCollateralValue.dividedBy(newDebt).gt(vaultInfo.minCollRatio)) {
        skipFL = true;
        [debtDelta, collateralDelta, oazoFee, loanFee] = increaseDecreaseMP_1.calculateParamsIncreaseMP(marketParams.oraclePrice, marketParams.marketPrice, marketParams.OF, new bignumber_js_1.BigNumber(0), //no FL Fee
        vaultInfo.currentCollateral.plus(desiredCdp.providedCollateral), vaultInfo.currentDebt.minus(desiredCdp.providedDai), desiredCdp.requiredCollRatio, marketParams.slippage, desiredCdp.providedDai, debug);
    }
    return {
        params: [debtDelta, collateralDelta, oazoFee, loanFee],
        skipFL,
    };
}
function calculateDecrease(marketParams, vaultInfo, desiredCdp, debug = false) {
    let debtDelta;
    let collateralDelta;
    let loanFee;
    let oazoFee;
    let skipFL;
    skipFL = false;
    //decrease multiply
    [debtDelta, collateralDelta, oazoFee, loanFee] = increaseDecreaseMP_1.calculateParamsDecreaseMP(marketParams.oraclePrice, marketParams.marketPrice, marketParams.OF, marketParams.FF, vaultInfo.currentCollateral.minus(desiredCdp.withdrawColl), vaultInfo.currentDebt.plus(desiredCdp.withdrawDai), desiredCdp.requiredCollRatio, marketParams.slippage, desiredCdp.providedDai, debug);
    const collateralLeft = vaultInfo.currentCollateral.minus(collateralDelta);
    const collateralLeftValue = collateralLeft.times(marketParams.oraclePrice);
    if (collateralLeftValue.dividedBy(vaultInfo.currentDebt).gt(vaultInfo.minCollRatio)) {
        skipFL = true;
        [debtDelta, collateralDelta, oazoFee, loanFee] = increaseDecreaseMP_1.calculateParamsDecreaseMP(marketParams.oraclePrice, marketParams.marketPrice, marketParams.OF, new bignumber_js_1.BigNumber(0), //no FL Fee
        vaultInfo.currentCollateral.minus(desiredCdp.withdrawColl), vaultInfo.currentDebt.plus(desiredCdp.withdrawDai), desiredCdp.requiredCollRatio, marketParams.slippage, desiredCdp.providedDai, debug);
    }
    return {
        params: [debtDelta, collateralDelta, oazoFee, loanFee],
        skipFL,
    };
}
function getMultiplyParams(marketParams, vaultInfo, desiredCdp, debug = false) {
    let debtDelta = new bignumber_js_1.BigNumber(0);
    let collateralDelta = new bignumber_js_1.BigNumber(0);
    let loanFee = new bignumber_js_1.BigNumber(0);
    let oazoFee = new bignumber_js_1.BigNumber(0);
    let skipFL = false;
    if (desiredCdp.withdrawColl.gt(0) || desiredCdp.withdrawDai.gt(0)) {
        const params = calculateDecrease(marketParams, vaultInfo, desiredCdp, debug);
        [debtDelta, collateralDelta, oazoFee, loanFee] = params.params;
        skipFL = params.skipFL;
        debtDelta = debtDelta.times(-1);
        collateralDelta = collateralDelta.times(-1);
    }
    else {
        if (desiredCdp.providedDai.gt(0) || desiredCdp.providedCollateral.gt(0)) {
            //increase multiply
            const params = calculateIncrease(marketParams, vaultInfo, desiredCdp, debug);
            [debtDelta, collateralDelta, oazoFee, loanFee] = params.params;
            skipFL = params.skipFL;
        }
        else {
            const currentCollRat = vaultInfo.currentCollateral
                .times(marketParams.oraclePrice)
                .dividedBy(vaultInfo.currentDebt);
            if (currentCollRat.lt(desiredCdp.requiredCollRatio)) {
                const params = calculateDecrease(marketParams, vaultInfo, desiredCdp, debug);
                [debtDelta, collateralDelta, oazoFee, loanFee] = params.params;
                skipFL = params.skipFL;
                debtDelta = debtDelta.times(-1);
                collateralDelta = collateralDelta.times(-1);
            }
            else {
                const params = calculateIncrease(marketParams, vaultInfo, desiredCdp, debug);
                [debtDelta, collateralDelta, oazoFee, loanFee] = params.params;
                skipFL = params.skipFL;
            }
        }
    }
    return {
        debtDelta: utils_1.ensureBigNumber(debtDelta),
        collateralDelta: utils_1.ensureBigNumber(collateralDelta),
        loanFee: utils_1.ensureBigNumber(loanFee),
        oazoFee: utils_1.ensureBigNumber(oazoFee),
        skipFL: skipFL,
    };
}
exports.getMultiplyParams = getMultiplyParams;
function getCloseToDaiParams(marketParams, vaultInfo) {
    const _skipFL = false;
    const _toTokenAmount = vaultInfo.currentCollateral
        .times(marketParams.marketPrice)
        .times(utils_1.one.minus(marketParams.OF));
    const _requiredDebt = vaultInfo.currentDebt.times(utils_1.one.multipliedBy(exports.OFFSET_MULTIPLAYER));
    const oazoFee = vaultInfo.currentCollateral.times(marketParams.marketPrice).minus(_toTokenAmount);
    const loanFee = vaultInfo.currentDebt.times(marketParams.FF);
    return {
        fromTokenAmount: vaultInfo.currentCollateral,
        toTokenAmount: _toTokenAmount,
        minToTokenAmount: _toTokenAmount.times(utils_1.one.minus(marketParams.slippage)),
        borrowCollateral: vaultInfo.currentCollateral,
        requiredDebt: _requiredDebt,
        withdrawCollateral: new bignumber_js_1.BigNumber(0),
        skipFL: _skipFL,
        loanFee: utils_1.ensureBigNumber(loanFee),
        oazoFee: utils_1.ensureBigNumber(oazoFee),
    };
}
exports.getCloseToDaiParams = getCloseToDaiParams;
function getCloseToCollateralParams(marketParams, vaultInfo, debug = false) {
    const _requiredAmount = vaultInfo.currentDebt
        .times(1.00001 /* to account for not up to date value here */)
        .times(utils_1.one.plus(marketParams.OF))
        .times(utils_1.one.plus(marketParams.FF));
    let _skipFL = false;
    const maxCollNeeded = _requiredAmount.dividedBy(marketParams.marketPrice.times(utils_1.one.minus(marketParams.slippage)));
    if (vaultInfo.minCollRatio !== undefined) {
        const collateralLocked = vaultInfo.currentDebt
            .dividedBy(marketParams.oraclePrice)
            .multipliedBy(vaultInfo.minCollRatio);
        if (vaultInfo.currentCollateral.minus(maxCollNeeded).gt(collateralLocked)) {
            _skipFL = true;
        }
    }
    const oazoFee = _requiredAmount.multipliedBy(marketParams.OF);
    const loanFee = _requiredAmount.times(marketParams.FF);
    return {
        fromTokenAmount: maxCollNeeded,
        toTokenAmount: _requiredAmount.dividedBy(utils_1.one.minus(marketParams.slippage)),
        minToTokenAmount: _requiredAmount,
        borrowCollateral: new bignumber_js_1.BigNumber(0),
        requiredDebt: _skipFL
            ? new bignumber_js_1.BigNumber(0)
            : vaultInfo.currentDebt.multipliedBy(exports.OFFSET_MULTIPLAYER),
        withdrawCollateral: new bignumber_js_1.BigNumber(0),
        skipFL: _skipFL,
        loanFee: utils_1.ensureBigNumber(loanFee),
        oazoFee: utils_1.ensureBigNumber(oazoFee),
    };
}
exports.getCloseToCollateralParams = getCloseToCollateralParams;
//# sourceMappingURL=calculateMultParams.js.map